import React from "react";
import { stageMeta, STAGES } from "../lib/stages";

export function StageBadge({ stage }) {
  const m = stageMeta(stage);
  return (
    <span className="tag" data-testid={`stage-${stage}`}>
      <span className="stage-dot" style={{ background: m.color }}></span>
      {m.label}
    </span>
  );
}

export function StageSelect({ value, onChange, testid = "stage-select" }) {
  return (
    <select
      data-testid={testid}
      value={value || "new"}
      onChange={(e) => onChange(e.target.value)}
      className="input-base"
      style={{ background: "var(--surface)", border: "1px solid var(--border)", padding: "10px 12px" }}
    >
      {STAGES.map((s) => (
        <option key={s.id} value={s.id}>{s.label}</option>
      ))}
    </select>
  );
}
